<template>
  <div class="container">
    <b-form>
      <label for="login">Name</label>
      <b-input id="login" v-model="user.login" ></b-input>
      <label for="name">Benutzername</label>
      <b-input v-model="user.name"></b-input>
      <label for="name">Passwort</label>
      <b-input v-model="user.password"></b-input>
      <b-form-checkbox
        v-model="user.type"
        value="admin"
        id="type"
        unchecked-value="user"
      >
        {{ $trans.user.is_admin }}
      </b-form-checkbox>
      <b-button class="btn btn-primary" @click="change()">{{ $trans.main.button_save }}</b-button>
    </b-form>
  </div>

</template>

<script>
import axios from 'axios'

export default {
  name: 'LocalUsers',
  data () {
    return {
      user: {
        name: '',
        login: '',
        password: '',
        type: 'user'
      }
    }
  },
  created () {
  },
  methods: {
    async change () {
      axios({
        url: 'users/',
        data: {
          login: this.user.login,
          name: this.user.name,
          password: this.user.password,
          type: this.user.type
        },
        method: 'POST'
      }).then(response => {
        this.$router.back()
      }).catch(error => {
        console.log(error.response.data)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/users/UserNew.vue